import { CheckboxProps } from '@procore/core-react/dist/_typedoc/Checkbox/Checkbox.types.json';
import * as React from 'react';
export default {
  CheckboxProps,
  React
};